import axios from "axios";
import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface GetSkusPendingMerchantSigningRequest {
  token: string;
}

const getSkusPendingMerchantSigning = async ({
  token,
}: GetSkusPendingMerchantSigningRequest) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/sku-finance/loan-application/pending-loan-agreement-signing`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default getSkusPendingMerchantSigning;
